export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"description","content":"Poolimate 2026 Companion App"},{"name":"theme-color","content":"#150C3A"}],"link":[{"id":"theme-link","rel":"stylesheet","href":"/themes/poolimate2026-dark/theme.css"},{"rel":"icon","href":"/favicon.ico"},{"rel":"apple-touch-icon","href":"/icons/180.png","sizes":"180x180"},{"rel":"mask-icon","href":"/logo.png","color":"#150C3A"}],"style":[],"script":[],"noscript":[],"title":"Poolimate 2026"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false